import { Address } from '@/models/address';

export enum ExportLock {
  None = 'none',
  Neak = 'neak',
  Pharmacy = 'pharmacy',
  Developer = 'developer',
}
export interface DoctorModel {
  $id?: string;
  address: null | Address;
  contactEmail: string;
  contactPhone: string;
  name: string;
  $isManager?: boolean;
  $exportLock: ExportLock;
  $isRegisteredUser?: boolean;
  $centerId?: null | string;
  $updatedAt?: Date;
  $createdAt?: Date;
}
